export default {
    tooltip: {
        enabled: 'Create trend radar',
        disabled: 'Once you have added macro-trends to this<br />work space, you can create a trend radar.'
    }
}
